<template>
  <div>

    <!-- Exibe a lista de produtos -->
    <div :class="isInputError('products')" @click="removeError('products')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">{{ $t('views.seller.integrations.config.save.product.title') }}</strong>
        <a href="#" @click.prevent="selectAll('products')" class="select-all float-right">
          {{ products?.value?.length > 0 ? $t('views.seller.integrations.config.save.product.remove_all') : $t('views.seller.integrations.config.save.product.select_all') }}
        </a>
      </div>
      <multiselect 
        v-model="products.value"
        :options="products.items" 
        :multiple="true" 
        :taggable="false"
        :show-labels="false" 
        :clear-on-select="false" 
        :close-on-select="false"
        :limit-text="limitText" 
        :limit="4" 
        :searchable="true"
        :loading="loadingProducts"
        :group-select="true"
        :select-label="'Select'"
        :disabled="loading"
        class="new-style"
        group-values="options"
        group-label="group"
        :placeholder="$t('views.seller.integrations.config.save.product.search')" 
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="option__title" v-if="props.option?.$isLabel">
            {{ props.option.$groupLabel.name }}
            <span class="label-info label-info--deselected">{{ $t('views.seller.integrations.config.save.product.select_all') }}</span>
            <span class="label-info label-info--selected">{{ $t('views.seller.integrations.config.save.product.remove_all') }}</span>
          </span>
          <span class="d-flex option__item" v-else>
            <img :src="isOptionSelected('products', props.option.id)" />
            {{ props.option.name }}
          </span>
        </template>
        <template #placeholder>
          <span class="select-title">{{ $t('views.seller.integrations.config.save.product.select') }}</span>
        </template>
        <span slot="noOptions">{{ $t('views.seller.integrations.config.save.product.no_items') }}</span>
        <span slot="noResult">{{ $t('views.seller.integrations.config.save.product.no_content') }}</span>
        <div slot="limit" class="multiselect__tag limit">+{{ products?.value?.length - 4 }}</div>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
      </multiselect>
      <span class="show-error">{{ showError('products') }}</span>
    </div>

    <!-- Exibe o token -->
    <div :class="isInputError('token')" @click="removeError('token')">
      <strong class="title-medium mt-4">API Key</strong>
      <b-form-group id="fieldset-token" label-for="input-token">
        <b-form-input id="input-token" :placeholder="`Informe o API Key do ${integration.name}`" class="form-input" v-model="token" :disabled="loading" @change="updateConnection" trim></b-form-input>
      </b-form-group>
      <span class="show-error">
        {{ showError('token') }}
      </span>
    </div>

    <!-- Exibe action -->
    <div :class="isInputError('action')" @click="removeError('action')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">Tipo</strong>
      </div>
      <multiselect 
        v-model="action.value"
        :options="action.items"
        :loading="action.loading"
        :disabled="action.block"
        :multiple="false" 
        :show-labels="false" 
        class="new-style"
        placeholder="Digite para pesquisar"
        track-by="name"
        label="name"
        @input="listItemsMemberkit"
        :searchable="false"
      >
        <template #option="props">
          <span class="d-flex option__item">{{ props.option.name }}</span>
        </template>
        <template #placeholder>
          <span class="select-title">Selecione a opção desejada</span>
        </template>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
      </multiselect>
      <span class="show-error">{{ showError('action') }}</span>
    </div>

    <!-- Exibe lista de items -->
    <div :class="isInputError('items')" @click="removeError('items')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left" v-if="action?.value?.value === 'subscription'">Assinatura</strong>
        <strong class="title-medium float-left" v-else>Turma/Curso</strong>
        <template v-if="action?.value?.value === 'classroom'">
          <a href="#" @click.prevent="selectAll('items', 'memberkit')" class="select-all float-right">
            {{ items?.value?.length > 0 ? $t('views.seller.integrations.config.save.product.remove_all') : $t('views.seller.integrations.config.save.product.select_all') }}
          </a>
        </template>
      </div>
      <template v-if="action?.value?.value === 'subscription'">
        <multiselect 
          v-model="items.value"
          :options="items.items" 
          :multiple="false" 
          :show-labels="false" 
          :searchable="true"
          :loading="items.loading"
          :disabled="items.block"
          placeholder="Digite para pesquisar"
          class="new-style"
          track-by="name"
          label="name"
        >
            <template #option="props">
              <span class="d-flex option__item">{{ props.option.name }}</span>
            </template>
            <template #placeholder>
              <span class="select-title">Selecione a opcao desejada</span>
            </template>
            <span slot="noOptions">Nenhum item disponível</span>
            <template #caret>
              <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
            </template>
        </multiselect>
      </template>
      <template v-else>
        <multiselect 
          v-model="items.value"
          :options="items.items" 
          :multiple="true" 
          :taggable="false"
          :show-labels="false" 
          :clear-on-select="false" 
          :close-on-select="false"
          :searchable="true"
          :loading="items.loading"
          :disabled="items.block"
          :select-label="'Select'"
          placeholder="Digite para pesquisar"
          class="new-style"
          track-by="name"
          label="name"
          :limit-text="limitText" 
          :limit="4"
        >
          <template #option="props">
            <span class="d-flex option__item">
              <img :src="isOptionSelected('items', props.option.id, null, items)" />
              {{ props.option.name }}
            </span>
          </template>
          <template #placeholder>
            <span class="select-title">Selecione os itens desejados</span>
          </template>
          <span slot="noOptions">Nenhum item disponível</span>
          <span slot="noResult">Nenhum item encontrado</span>
          <div slot="limit" class="multiselect__tag limit">+{{ items?.value?.length - 4 }}</div>
          <template #caret>
            <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
          </template>
        </multiselect>
      </template>
      <span class="show-error">{{ showError('items') }}</span>
    </div>

    <!-- Botao Salvar -->
    <b-button class="btn-confirm mt-4" variant="primary" :disabled="loading || loadingSave" @click="saveItegration">
      <template v-if="loadingSave">
        <b-spinner variant="light" class="mr-2" small></b-spinner>
        {{ $t('views.seller.integrations.config.save.button.saving') }}
      </template>
      <template v-else>
        {{ $t('views.seller.integrations.config.save.button.save') }}
      </template>
    </b-button>

  </div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import MemberKitService from "@/services/resources/MemberKitService";
import ReleaseRuleService from "@/services/resources/ReleaseRuleService";

export default {
  name: "IntegrationsConfigMemberkit",
  components: {
    Multiselect
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    loadingProducts: {
      type: Boolean,
      required: true
    },
    integration: {
      type: Object,
      required: true,
      default: () => ({ name: 'Memberkit' })
    },
    products: {
      type: Object,
      required: true,
      default: () => ({
        value: null,
        items: [
          {
            group: {
              name: '',
            },
            options: [],
          }
        ],
      })
    },
    mountInputError: {
      type: Function,
      required: true
    },
    isInputError: {
      type: Function,
      required: true
    },
    removeError: {
      type: Function,
      required: true
    },
    showError: {
      type: Function,
      required: true
    },
    selectAll: {
      type: Function,
      required: true
    },
    isOptionSelected: {
      type: Function,
      required: true
    },
    limitText: {
      type: Function,
      required: true
    },
    fetchCallbacks: {
      type: Function,
      required: true
    },
  },
  data: () => {
    return {
      loadingSave: false,
      token: '',
      action: {
        block: true,
        loading: false,
        value: null,
        items: [
          {
            name: 'Assinatura',
            value: 'subscription'
          },
          {
            name: 'Turmas',
            value: 'classroom'
          }
        ]
      },
      items: {
        block: true,
        loading: false,
        value: null,
        items: []
      }
    }
  },
  methods: {
    resetForm() {
      this.products.value = null;
      this.token = '';
      this.action.value = null;
      this.items.value = null;
    },
    updateConnection() {
      if (this.token) {
        MemberKitService.build().read(`test?token=${this.token}`, { suppressErrorNotify: true })
        .then(() => {
          this.action.block = false;
        })
        .catch(err => {
          this.mountInputError(err.response.data);
          this.action.block = true;
          this.action.value = null;
          this.items.block = true;
          this.items.value = null;
        })
        .finally(() => {
          this.action.loading = false;
        });
      }
    },
    listItemsMemberkit(selectedValue) {
      
      this.items.value = [];

      if (!selectedValue?.value) {
        this.items.block = true;
        this.items.loading = false;
        return;
      }

      this.items.loading = true;

      MemberKitService.build().read(`${selectedValue.value}?token=${this.token}`, { suppressErrorNotify: true })
      .then(response => {
        
        this.items.block = false;
        let items = response;

        if(selectedValue.value === 'classroom') {
          items = items.map(item => {
            item.name = `${item.course_name} | ${item.name}`;
            return item;
          });
        }

        this.items.items = items;
      })
      .catch(() => {
        this.items.items = [];
        this.items.block = true;
      })
      .finally(() => {
        this.items.loading = false;
      });
    },
    saveItegration() {

      const products = this.products?.value?.map(product => product.id) || [];
      const access = this.action?.value?.value || null;

      const data = {
        access: access,
        type: 'memberkit',
        token: this.token,
        products: products
      };

      if (access === 'subscription') {
        data.membership_id = this.items.value.id;
        data.membership_name = this.items.value.name;
      } else if (access === 'classroom') {
        data.classroom_ids = this.items.value.map(item => item.id);
        data.classroom_names = this.items.value.map(item => item.name);
      }

      ReleaseRuleService.build().post('/group', data, { suppressErrorNotify: true })
      .then(() => {
        
        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.save.success.message'), {
          title: this.$t('views.seller.integrations.config.toast.save.success.title'),
          variant: "success",
          autoHideDelay: 5000,
          appendToast: true,
        });

        this.resetForm();
        this.fetchCallbacks();
      })
      .catch(err => {
        if (this.action.block && err.response.data.access && !err.response.data.token) {
          err.response.data.token = ['Token inválido'];
        }
        else if (!this.action.block && err.response.data.access) {
          err.response.data.action = ['Selecione a opção desejada'];
        }
        else if (err.response.data.membership_id || err.response.data.classroom_ids) {
          err.response.data.items = ['Selecione a opção desejada'];
        }

        this.mountInputError(err.response.data);
      })
    }
  }
}
</script>